import React, { useState, useEffect } from 'react';
import { Project } from '../../store/slices/projectsSlice';
import Button from '../UI/Button';
import {
  InlineEditText,
  InlineEditSelect,
} from '../UI/InlineEdit';
import { api } from '../../services/api';
import UserInfo from '../UI/UserInfo';

interface ProjectHeaderProps {
  project: Project;
  isOwner?: boolean;
  onEdit?: () => void;
  onFieldUpdate?: (field: string, value: any) => Promise<void> | void;
}

const ProjectHeader: React.FC<ProjectHeaderProps> = ({ project, isOwner, onEdit, onFieldUpdate }) => {

  const [categories, setCategories] = useState<any[]>([]);
  useEffect(() => {
    const loadCategories = async () => {
      try {
        const data = await api.categories.getAll();
        setCategories(data);
      } catch (error) {
        console.error('Error loading categories:', error);
      }
    };
    loadCategories();
  }, []);

  const ownerInfo = project.ownerId;

  const statusOptions = [
    { value: 'draft', label: 'Draft' },
    { value: 'planned', label: 'Planned' },
    { value: 'scheduled', label: 'Scheduled' },
    { value: 'active', label: 'Active' },
    { value: 'vote_session', label: 'Vote Session' },
    { value: 'canceled', label: 'Canceled' },
    { value: 'suspended', label: 'Suspended' },
    { value: 'failed', label: 'Failed' },
    { value: 'executed', label: 'Executed' },
  ];

  const categoryOptions = categories.map((cat) => ({
    value: cat.slug || cat.name,
    label: cat.name,
  }));

  return (
    <div className="bg-[var(--color-default-background)] rounded-lg shadow-sm p-6 mb-6">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <div className="mb-2">
            <InlineEditText
              value={project.title}
              onSave={(value) => onFieldUpdate?.('title', value)}
              disabled={!isOwner}
              className="text-4xl font-bold text-[var(--color-default-font)]"
              showEditButton={isOwner}
            />
          </div>
          <div className="flex items-center gap-4 text-sm text-[var(--color-subtext-color)] flex-wrap">
            <InlineEditSelect
              value={project.category}
              onSave={(value) => onFieldUpdate?.('category', value)}
              options={categoryOptions}
              disabled={!isOwner}
              className="capitalize"
              showEditButton={isOwner}
            />
            <span>•</span>
            <span>{project.geographicRegion?.parish}</span>
            <span>•</span>
            <div className="flex items-center gap-2">
              <span className="text-[var(--color-subtext-color)]">By</span>
              <UserInfo user={ownerInfo} size="sm" showBadges={true} showReputation={true} />
            </div>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <InlineEditSelect
            value={project.status}
            onSave={(value) => onFieldUpdate?.('status', value)}
            options={statusOptions}
            disabled={!isOwner}
            className=""
            showEditButton={isOwner}
          />
          {isOwner && onEdit && (
            <Button variant="outline" size="sm" onClick={onEdit}>
              Full Edit
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectHeader;

